import { useMutation } from "@apollo/client";
import { SAVE_GENERAL_SETTINGS_MUTATION } from "../mutations/mutations";

/**
 * 
 * @typedef {Object} DomainSettingsSaveOptions - Configuration options.
 * @property {string} id - The domain ID.
 * @property {string} advPreset - The preset ID.
 * @property {string} industryOptions - Industry options.
 * @property {string} networkId - The network ID.
 * @property {string} childnetworkId - The child network ID.
 * @property {string} enableCLS - Enable CLS.
 * @property {string} overrideSiteCSS - Override site CSS.
 * @property {string} ads_ActiveViewTime - Ads active view time.
 * @property {string} shortDomainName - Short domain name.
 * @property {string} bannerFloorsPrice - Banner floors price.
 * @property {string} overrideDynamicFloors - Override Dynamic Floors.
 * @property {string} enableDynamicFloors - Enable Dynamic Floors.
 * @property {string} dynamicFloorsPercentage - Dynamic Floors Percentage.
 * @property {string} adEnableSandboxMode - Enable sandbox mode for ads.
 * @property {string} adEnableAdhesionIcon - Enable adhesion icon for ads.
 * @property {string} adInactive - Set ads as inactive.
 * @property {string} sendAllBids - Send all bids.
 * @property {string} adDisableHBGlobally - Disable header bidding globally.
 * @property {string} adDisableHB_GloballyByCountries - Disable header bidding globally by countries.
 * @property {string} adOverridePrebidTimeout - Override Prebid timeout.
 * @property {string} adPrebidTimeout - Prebid timeout.
 * @property {string} adEnableVideoWrapper - Enable video wrapper for ads.
 * @property {string} adgVersion - Adg version.
 * @property {string} stagingURL - Staging URL.
 * @property {string} domainMarketplaceNetworks - Domain marketplace networks.
 * @property {string} enable_marketplace - Enable marketplace.
 * @property {string} marketplaceDomainOverviewData - Marketplace domain overview data.
 * @property {string} marketplaceEmailsList - Marketplace emails list.
 * @property {string} video_player_type - Video player type.
 * @property {string} advertisement_label_text - Advertisement label text.
 * @property {string} advertisement_label_align - Advertisement label alignment.
 * @property {string} advertisement_label_position - Advertisement label position.
 * @property {string} stickyHeaderHeight - Sticky header height.
 * @property {string} stickyHeaderHeightTab - Sticky header height for tablets.
 * @property {string} stickyHeaderHeightMob - Sticky header height for mobile.
 * @property {string} fromHBSettings - From HB settings.
 * @property {string} overrideDisableHBGlobally - Override disable header bidding globally.
 * @property {string} playerVendor - Player vendor.
 * @property {string} bridPartnerId - Brid Partner ID
 * @property {string} bridApiKey - Brid API Key
 * @property {boolean} isWrapperDomain
 * @property {boolean} isAdapterDomain
 */

/**
 * 
 * @param {Object} options 
 * @returns {(options: DomainSettingsSaveOptions) => Promise<Object>}
 */

export function useGeneralDomainSettingsSave(options = {}) {
    const [container] = useMutation(SAVE_GENERAL_SETTINGS_MUTATION, options)

    /**
     * @param {DomainSettingsSaveOptions} domainData
     */
    return (domainData) => {
        domainData.id = domainData.id && String(domainData.id)
        domainData.advPreset = domainData.advPreset && String(domainData.advPreset)

        for (let p in domainData) {
            if (domainData[p] === null || domainData[p] === undefined)
                delete domainData[p]
        }

        return container({ variables: domainData })
    }
}
